import React from 'react';

interface DealPageColProps {
  title: string;
  subTitle?: string;
  children: JSX.Element;
  fullWidth?: boolean;
}

const DealPageCol = ({
  title,
  subTitle,
  children,
  fullWidth = false,
}: DealPageColProps) => {
  return (
    <div
      className={`flex h-full w-full ${
        fullWidth ? '' : 'rounded-2xl'
      } bg-white`}
    >
      <div className="flex w-full flex-col">
        <div className="w-full pt-6">
          <div className="px-6 font-gt-haptik text-heading-5-mobile font-bold text-black md:text-heading-5">
            {title}
          </div>
          {subTitle && (
            <div className="px-6 text-sm text-neutral-50">{subTitle}</div>
          )}
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};
export default DealPageCol;
